import { ElNotification } from 'element-plus';
export const notification = (title)=>ElNotification.success({
        title,
        message: '',
        position: 'bottom-right'
    });
